import { EmailOfferStrip } from "./EmailOfferStrip";

interface IEmailOfferStripV2 {
  customClasses?: string | undefined;
  isVisible?: boolean;
}

export const EmailOfferStripV2 = ({ customClasses = "", isVisible = false }: IEmailOfferStripV2) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={
        "ds-font-manrope tw-flex tw-items-center tw-gap-[9px] tw-rounded-bl-[8px] tw-rounded-br-[8px] tw-rounded-tl-[8px] tw-rounded-tr-[8px] tw-px-[11px] tw-py-[13px] " +
        customClasses
      }
      style={{
        background: "#EFEDFF",
      }}
    >
      <EmailOfferStrip
        raw
        mini
        customClasses="tw-ml-0 !tw-pl-[4px] !tw-pr-[3px] !tw-py-[1px]"
        fontSize="tw-text-[9px]"
      />
      <p className="tw-m-0 tw-text-[13px] tw-font-semibold">Get a branded email account on renewing this domain</p>
    </div>
  );
};
